import { z } from 'zod/v4';

export const termsAcceptedSchema = z.preprocess(
  (value) => typeof value === 'number' && value > 0,
  z.boolean()
);
